<app-popup class="job-share">
  <button
    class="job-share__btn btn-clean"
    type="button"
    aria-label="Partager"
    i18n-aria-label
    appPopupTrigger
    (click)="openShare.emit()"
  >
    <svg-icon class="job-share__btn-icon" icon="share" width="1.3em"></svg-icon>
  </button>

  <div class="job-share__menu" appPopupItem>
    <a
      *ngFor="let item of shareLinks; index as i; trackBy: trackByLabel"
      class="job-share__link"
      [href]="item.url"
      target="_blank"
      rel="noopener"
      (click)="share.emit(item.media.label)"
      appEventTracker
      eventCategory="Job"
      eventAction="Click Share"
      [eventValue]="item.media.label"
    >
      <svg-icon class="job-share__icon" [icon]="item.media.icon" width="1.625em"></svg-icon>
      {{ item.media.label }}
    </a>
  </div>
</app-popup>
